import { mapGetters } from 'vuex'
import config from 'services/config'

export default {
    computed: {
        ...mapGetters({
            isReportingAllowed: 'User/getIsReportingAllowed',
            selectedLanguage: 'Languages/getSelectedCountryCode',
            packageInfo: 'User/getPackageInfo',
            userId: 'getUserId'
        }),
        isChatBotPackage() {
            return this.packageInfo.find(el => el.code === 'fi-chatbot') !== undefined
        }
    },
    methods: {
        async showFindingContentModal() {
            const modalKey = `hasSeenFindingContentModal_${this.userId}`

            if (!localStorage.getItem(modalKey)) {
                this.$modal.show('finding-content-popup')
                localStorage.setItem(modalKey, 'true')
            }
        }
        /*
        async showEvaGeneralModal () {
             if (config.appLanguage === 'no') {
                 this.$modal.show('eva-general-popup-norway')
             }
             if (config.appLanguage === 'se') {
                 this.$modal.show('eva-general-popup-sweden')
             }
         }
         */
    }
}
